import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import api from "../lib/api";
import TestimonialForm from "./TestimonialForm";
import { useLang } from "../i18n/LanguageContext";

export default function Testimonials() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/testimonials")
      .then((r) => alive && setItems(r.data || []))
      .catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, []);



  const textFor = (v) => (lang === "bn" && v.text_bn) || (lang === "hi" && v.text_hi) || v.text_en;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 sm:pb-24" data-testid="voices-section">
      {items.length > 0 && (
        <Reveal variant="blur" className="max-w-xl mb-12">
          <span className="text-[11px] font-serif tracking-[0.28em] uppercase text-tara-goldDeep">{t("voices_eyebrow")}</span>
          <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-tara-ink mt-3">{t("voices_title")}</h2>
          <div className="rule-gold mt-5" />
        </Reveal>
      )}

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.slice(0, 6).map((v, i) => (
          <Reveal
            key={v.id}
            variant="up"
            delay={(i % 3) * 0.08}
            className="glass hover-lift rounded-[1.6rem] p-7 relative"
            data-testid={`voice-card-${i}`}
          >
            <Quote className="absolute right-6 top-6 h-7 w-7 text-tara-gold/20" />
            <span className="flex items-center gap-1 text-tara-gold mb-4">
              {Array.from({ length: v.rating || 5 }).map((_, s) => (
                <Star key={s} className="h-3.5 w-3.5 fill-current" />
              ))}
            </span>
            <p className="font-display text-lg text-tara-ink leading-relaxed italic mb-5">“{textFor(v)}”</p>
            <footer className="text-xs uppercase tracking-[0.16em] text-tara-muted">
              {v.name}
              {v.location ? ` · ${v.location}` : ""}
            </footer>
            {v.service_title && <p className="text-[11px] text-tara-gold mt-1.5">{v.service_title}</p>}
          </Reveal>
        ))}
      </div>

      <div className={`max-w-3xl ${items.length > 0 ? "mt-10" : ""}`}>
        <TestimonialForm />
      </div>
    </section>
  );
}
